module.exports = __webpack_public_path__ + "static/media/hexagon-work.dc05959e.svg";